import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'limitArray',
  standalone: false
})
export class LimitArrayPipe implements PipeTransform {
    transform(ary: any[], max: number) {
        return ary.splice(0, max)
    }
}